<template>
  <div class="linkage-secret-list">
    <div class="steps-wrapper">
      <p class="steps-title">网约营运数据共享开通步骤</p>
      <el-steps
        class="steps"
        :active="5"
        finish-status="process"
        align-center
        :space="200"
      >
        <el-step class="step">
          <div slot="description" class="step-description">
            复制专属ID给网约合作商申请数据共享码
          </div>
        </el-step>
        <el-step class="step">
          <div slot="description" class="step-description">
            录入网约合作商提供的数据共享码
          </div>
        </el-step>
        <el-step class="step">
          <div slot="description" class="step-description">
            校验通过后等待网约合作商确认
          </div>
        </el-step>
        <el-step class="step">
          <div slot="description" class="step-description">
            网约合作商确认后共享数据关系建立完成
          </div>
        </el-step>
      </el-steps>
    </div>
    <div class="operation-wrapper">
      <div class="secret-id-wrapper">
        <el-button
          class="copy-btn"
          type="primary"
          @click="copySecretId(secretId)"
          >复制我的专属ID</el-button
        >
      </div>
      <div class="share-id-wrapper">
        <p class="share-id-title">网约合作商数据共享码</p>
        <el-input
          class="share-id-input"
          placeholder="请输入数据共享码"
          v-model="shareId"
          clearable
        >
        </el-input>
        <el-button
          class="check-btn"
          type="primary"
          :disabled="!shareId"
          @click="checkShareId(shareId)"
          >校验</el-button
        >
      </div>
    </div>
    <div class="list-wrapper">
      <QS-common-table
        :data="tableData"
        :columns="tableColumns"
        :span-method="objectSpanMethod"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
      >
      </QS-common-table>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { copyToClipboard } from '@/utils/index'
import {
  getSecretId,
  getShareIdList,
  checkShareId,
  closeShareId,
} from '@/api/domain/organize'
import { CLOSE_TYPES, SHARE_STATUS } from './config'
import { operateMaxShowLength } from '@/store/dict/config'

const LOADING_PARAMS = {
  lock: true,
  text: 'Loading',
  spinner: 'QS-icon-loading',
  background: 'rgba(255, 255, 255, 0.7)',
}

export default {
  data() {
    return {
      secretId: '',
      shareId: '',
      tableData: [],
      tableColumns: [
        {
          name: 'spName',
          columnProps: {
            label: '网约运营合作商',
            prop: 'spName',
          },
        },
        {
          name: 'shareId',
          columnProps: {
            label: '共享ID',
            prop: 'shareId',
          },
        },
        {
          name: 'startTime',
          columnProps: {
            label: '共享开始时间',
            prop: 'startTime',
          },
        },
        {
          name: 'endTime',
          columnProps: {
            label: '共享计划结束时间',
            prop: 'endTime',
          },
        },
        {
          name: 'closeTime',
          columnProps: {
            label: '共享关闭时间',
            prop: 'closeTime',
          },
        },
        {
          name: 'closeType',
          columnProps: {
            label: '关闭类型',
            prop: 'closeType',
          },
          render: ({ row }) => CLOSE_TYPES[row.closeType].label || '--',
        },
        {
          name: 'shareState',
          columnProps: {
            label: '共享状态',
            prop: 'shareState',
          },
          render: ({ row }) => SHARE_STATUS[row.shareState].label || '--',
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
          },
          maxShowLength: operateMaxShowLength,
          getOperateList: ({ row }) => {
            // 1:进行中 3:等待共享
            if ([1, 3].includes(row.shareState)) {
              return [
                {
                  name: 'operate1',
                  label: '关闭共享',
                  action: () => this.closeShareId(row.shareId),
                },
              ]
            }
            return []
          },
          type: 'operate',
        },
      ],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
      loading: false,
    }
  },
  methods: {
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex <= 0) {
        if (rowIndex === 0 || row.spId !== this.tableData[rowIndex - 1].spId) {
          let rowspan = 0
          this.tableData.forEach((item) => {
            if (item.spId === row.spId) {
              rowspan++
            }
          })
          return [rowspan, 1]
        } else {
          return [0, 0]
        }
      }
      return [1, 1]
    },
    // 获取专属ID
    async getSecretId() {
      let res

      try {
        res = await getSecretId({
          type: 90, // 90网约运营数据
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1) {
        const { idSecret: secretId = '' } = data
        this.secretId = secretId
      }
    },
    // 获取共享Id列表
    async getShareIdList() {
      let res

      this.loading = true
      try {
        res = await getShareIdList({
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
        })
      } catch (err) {
        console.error(err)
      }
      this.loading = false

      if (!res) return

      const { code, data } = res

      if (code === 1) {
        const { items = [], totalNum = 0 } = data
        this.tableData = items
        this.pagination.total = totalNum
      }
    },
    // 复制专属ID
    copySecretId(secretId) {
      copyToClipboard(secretId, () => {
        this.$message.success('已复制')
      })
    },
    // 校验共享ID
    checkShareId(shareId) {
      const check = async () => {
        let res

        try {
          res = await checkShareId({
            shareSecret: shareId,
          })
        } catch (err) {
          console.error(err)
        }

        if (!res) return

        const { code, data } = res

        if (code === 1 && data) {
          this.$message.success('验证成功')
          setTimeout(() => {
            this.getShareIdList()
          }, 1500)
        }
      }

      this.$confirm(
        '点击校验按钮后将会同网约合作商建立共享关系，将同步与第三方合作商共享相关数据，数据的具体内容及范围以实际共享为准。',
        '温馨提示',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
        },
      )
        .then(() => {
          check()
        })
        .catch(() => null)
    },
    // 关闭共享
    closeShareId(shareId) {
      const close = async () => {
        let res

        const loading = this.$loading(LOADING_PARAMS)

        try {
          res = await closeShareId({
            shareId,
          })
        } catch (err) {
          console.error(err)
        }

        loading.close()

        if (!res) return

        const { code, data } = res

        if (code === 1 && data) {
          this.$message.success('关闭成功')
          setTimeout(() => {
            this.getShareIdList()
          }, 1500)
        }
      }

      this.$confirm(
        '是否确认提前关闭共享？关闭后如需再次开启，需要重新向网约合作商获取数据共享密钥',
        '关闭共享确认',
        {
          confirmButtonText: '确认关闭',
          cancelButtonText: '取消',
        },
      )
        .then(() => {
          close()
        })
        .catch(() => null)
    },
    handleTableChange(payload) {
      const { pagination } = payload
      this.pagination.pageNum = pagination.pageNum
      this.pagination.pageSize = pagination.pageSize

      this.getShareIdList()
    },
  },
  created() {
    this.getSecretId()
    this.getShareIdList()
  },
}
</script>
<style lang="scss" scoped>
.steps-title {
  margin: 0 0 16px 16px;
  font-weight: bold;
  color: #323233;
}
.steps-wrapper {
  padding: 12px 0 16px 0;
  background: #ebedf0;
  border-radius: 6px;
  .steps {
    width: 100%;
  }
  .step {
    flex: 1;
  }
  .step-description {
    color: #323233;
  }
}
.operation-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 12px 12px 0 12px;
}
.share-id-wrapper {
  display: flex;
  .share-id-title {
    flex: none;
  }
  .share-id-input {
    flex: none;
    width: 240px;
    margin-left: 24px;
  }
  .check-btn {
    flex: none;
    margin-left: 12px;
  }
}

::v-deep .el-table__row:hover td.el-table_1_column_1 {
  background: #fff !important;
}
</style>
